import React from 'react';
import PropTypes from 'prop-types';

const ExhibitorTotal = ({
  total, defaultTitle, titleWhenSearching, isSearchResult, tags
}) => {
  const label = `${isSearchResult ? titleWhenSearching : defaultTitle}`;
  if (label.includes('{0}')) {
    return (<span data-dtm={tags.searchResultCount}>{`${label.replace('{0}', total)}`}</span>);
  }
  return (
    <span data-dtm={tags.searchResultCount}>{`${total} ${label}`}</span>
  );
};

ExhibitorTotal.propTypes = {
  total: PropTypes.number.isRequired,
  defaultTitle: PropTypes.string.isRequired,
  titleWhenSearching: PropTypes.string,
  isSearchResult: PropTypes.bool,
  tags: PropTypes.object.isRequired
};

export default ExhibitorTotal;
